export function NotFoundLinkPage() {
  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="max-w-md text-center space-y-3">
        <h1 className="text-xl font-semibold">This link is invalid</h1>
        <p className="text-sm text-muted-foreground">
          The link you followed is not recognized. Please double-check the URL or ask the sharing
          clinician for a new one.
        </p>
      </div>
    </div>
  );
}
